import React, { useState, useEffect } from 'react';
import CardMainProperty, { CardMainPropertyInfo } from 'src/components/AnageImoveis/CardMainProperty';
import SwiperCore, {
  Navigation, Scrollbar, A11y
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ManagerApi from 'src/services/managerApi';

SwiperCore.use([Navigation, Scrollbar, A11y]);

export default function MainProperties() {
  const realEstateApi = new ManagerApi('/realestate');
  const [realEstatesBuy, setRealEstatesBuy] = useState(null);
  const [activeRealState, setActiveRealState] = useState(realEstatesBuy?.[0]);

  const fetchRealEstate = (filter, callbackSet) => {
    realEstateApi.getList({
      ...filter,
      paginator: {
        pageItemsPerPage: 20,
        sortOrder: {
          createdAt: 'DESC'
        }
      }
    }).then((response) => {
      if (response.data.success) {
        const list = [];
        let cont = 0;
        while (cont < 5) {
          const randomIndex = Math.floor(Math.random() * response.data.content.length);
          list.push(response.data.content.splice(randomIndex, 1)[0]);
          cont++;
        }
        callbackSet(list);
      }
    })
      .catch(() => {})
      .then(() => {});
  };

  const handleSlideChange = (swiper) => {
    setActiveRealState(realEstatesBuy?.[swiper.activeIndex]);
  };

  useEffect(() => {
    fetchRealEstate({
      status: 'comprar',
      featured: 0,
      tagSelect: 1,
      tagSeloSelect: 1
    }, setRealEstatesBuy);
  }, []);

  useEffect(() => {
    if (!!realEstatesBuy?.length && !activeRealState) {
      setActiveRealState(realEstatesBuy[0]);
    }
  }, [realEstatesBuy]);

  return (
    <div className="home-hero">
      {realEstatesBuy?.map((realEstate) => (
        <div
          key={realEstate.id}
          className={`card-main-property-cover card-main-property-cover--desktop ${activeRealState?.id !== realEstate.id ? 'd-none' : ''}`}
        >
          <div className="card-main-property-cover-background" />
          <div className="card-main-property-cover-overlay" />
          <div className="card-main-property-cover-content">
            <CardMainPropertyInfo realEstate={realEstate} />
          </div>
        </div>
      ))}

      {realEstatesBuy && (
        <div className="card-main-property-swipper-images">
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            onSlideChange={handleSlideChange}
            modules={[Navigation]}
            navigation={{
              prevEl: '.swiper-custom-button-prev',
              nextEl: '.swiper-custom-button-next',
            }}
          >
            {realEstatesBuy.map((realEstate) => (
              <SwiperSlide>
                <CardMainProperty realEstate={realEstate} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      {realEstatesBuy?.map((realEstate) => (
        <div
          key={realEstate.id}
          className={`card-main-property-cover-content ${activeRealState?.id !== realEstate.id ? 'd-none' : ''}`}
        >
          <CardMainPropertyInfo realEstate={realEstate} />
        </div>
      ))}
    </div>
  );
}
